import { useLayoutEffect } from 'react';

export const useBodyClass = (className: string) => {
  useLayoutEffect(() => {
    if (!className) {
      return;
    }
    document.body.classList.add(className);
    return () => {
      document.body.classList.remove(className);
    };
  }, [className]);
};
